import * as React from "react";
import { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { isNil } from "ramda";

import { Layout } from "affinityUI/structures/layout";
import { Patient } from "components/views/patientDetails/patient";
import { Restricted } from "lib/auth";
import { PERMISSIONS } from "lib/biot/roles/types";
import { usePreviousLocation } from "lib/previousLocation";

import { usePatient } from "../context";

export const PatientPage: React.FC = () => {
  const { patient, loading } = usePatient();

  const previousLocation = usePreviousLocation();
  const backLink =
    previousLocation?.pathname === "/patients/search"
      ? `${previousLocation?.pathname}${previousLocation?.search}`
      : "/patients";

  const title = patient ? `${patient.firstName} ${patient.lastName}` : "";
  const detailsActions = useMemo(
    () =>
      patient ? (
        <Restricted permits={[PERMISSIONS.PATIENT_CHANGE]}>
          <NavLink data-testid="edit-patient" to="edit">
            Edit
          </NavLink>
        </Restricted>
      ) : null,
    [patient]
  );

  return (
    <Layout title={title} showBackBtn backLinkText="Back to patients" backLink={backLink} loading={loading}>
      {!loading && !isNil(patient) ? <Patient patient={patient} detailsActions={detailsActions} /> : null}
    </Layout>
  );
};
